// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"5":"377201ae","796":"687c3d96"}[chunkId] + ".js";
};